import { Fragment, type ReactNode } from 'react';

/**
 * Render markdown-lite: only **bold** segments are recognized.
 * Used inline inside bullet text (Fiche schema allows it).
 *
 * Optionally tints bold segments with an accent color (CSS color string).
 */
export function renderMarkdownLite(text: string, options: { boldColor?: string } = {}): ReactNode {
  const parts: ReactNode[] = [];
  const matches = Array.from(text.matchAll(/\*\*([^*]+)\*\*/g));
  let last = 0;
  for (const m of matches) {
    const start = m.index ?? 0;
    if (start > last) {
      const segment = text.slice(last, start);
      parts.push(<Fragment key={`t-${last}-${segment.length}`}>{segment}</Fragment>);
    }
    parts.push(
      <b
        key={`b-${start}-${m[1]?.length ?? 0}`}
        style={
          options.boldColor ? { color: options.boldColor, fontWeight: 700 } : { fontWeight: 700 }
        }
      >
        {m[1]}
      </b>,
    );
    last = start + m[0].length;
  }
  if (last < text.length) {
    const segment = text.slice(last);
    parts.push(<Fragment key={`t-${last}-${segment.length}`}>{segment}</Fragment>);
  }
  return parts;
}
